<script>
	import { slide } from 'svelte/transition';

	let { label, children, error = null, class: className = '' } = $props();
</script>

<div
	class={[
		`
    relative mb-3
    nth-of-type-[odd]:last-of-type:col-span-full
  `,
		className,
	]}
>
	{#if label}
		<div class="mb-2">
			{label}
		</div>
	{/if}

	{@render children?.()}

	{#if error}
		<div transition:slide class="col-span-full mt-2 text-left text-indow-red">
			{error}
		</div>
	{/if}
</div>
